// admin/src/Component/FacebookConversion/Edit.js

import React from 'react';
import {
    regex,
    Edit,
    SimpleForm,
    TextInput,
    required,
    ReferenceInput,
    SelectInput,
    BooleanInput
} from 'react-admin';
import IdFieldWithCopy from './IdFieldWithCopy';

const validateUrl = regex(/^(ftp|http|https):\/\/[^ "]+$/, 'Must be a valid url');
const requiredUrl = [required(), validateUrl];

export const FacebookConversionEdit = (props) => {

    return (
    <Edit title="Edit facebook conversion " { ...props }>
        <SimpleForm>

            <IdFieldWithCopy source="id" />

            <BooleanInput source="active" label="Active" />
            <BooleanInput source="facebook_enabled" label="Also throw facebook pixel" />
            <TextInput source="name" label="Name" validate={ required() } />
            <TextInput source="url" label="URL" validate={ requiredUrl } />
            <TextInput source="data_layer" label="Data layer" validate={ required() } />

            <ReferenceInput label="SameSite" source="cookie_consent_same_site" reference="cookie-consent-same-sites" validate={ required() }>
                <SelectInput optionText="name" />
            </ReferenceInput>

            <TextInput source="currency" label="Currency" defaultValue="EUR" validate={ required() } />
            <TextInput source="pixel_id" label="Pixel ID" validate={ required() } />
            <TextInput source="access_token" label="Access token" validate={ required() } />

        </SimpleForm>
    </Edit>
    );
};
